/**
 * Format a note's `created_by` full-name into the compact form used in
 * the project board tables: "First L."
 *
 *   formatNoteAuthor('Michael Paparone') -> 'Michael P.'
 *   formatNoteAuthor('Mike')             -> 'Mike'
 *   formatNoteAuthor('')                 -> ''
 *   formatNoteAuthor(null)               -> ''
 */
export function formatNoteAuthor(fullName) {
  if (!fullName || typeof fullName !== 'string') return '';
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0];
  const first = parts[0];
  const lastInitial = parts[parts.length - 1][0];
  return `${first} ${lastInitial}.`;
}
